export default "__VITE_ASSET__1613e592__"